import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import IceBuoyChart from './IceBuoyChart'
import ChartActions from '../redux/chartRedux'
import Typography from '@material-ui/core/Typography'
import Collapse from '@material-ui/core/Collapse'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'

const styles = theme => ({
  wrapperInner: {
    height: '100%',
    overflow: 'visible'
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  flexGrow: {
    flex: '1 1 auto'
  },
  overflowVisible: {
    overflow: 'hidden'
  }
})

class IceBuoyChartContainer extends Component {
  constructor () {
    super()
    this.state = {
      expanded: true
    }
  }

  handleExpandClicked = () => {
    const { expanded } = this.state
    this.setState({ expanded: !expanded })
  }

  render () {
    const { classes } = this.props
    const { expanded } = this.state
    const title = 'SmartBUOY'

    return (
      <Collapse
        component='div'
        in={true}
        unmountOnExit
        classes={{
          wrapperInner: classes.wrapperInner,
          container: classes.overflowVisible
        }}
      >
        <Toolbar>
          <Typography>{title}</Typography>
          <div className={classes.flexGrow} />
          <IconButton
            className={classes.expand}
            onClick={this.handleExpandClicked}
            aria-expanded={expanded}
            aria-label='Show more'
          >
            {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Toolbar>
        <Collapse
          in={expanded}
          classes={{
            wrapperInner: classes.wrapperInner,
            container: classes.overflowVisible
          }}
        >
          <IceBuoyChart />
        </Collapse>
      </Collapse>
    )
  }
}

const mapStateToProps = state => {
  return {
    chartPanelOpen: state.chart.chartPanelOpen
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      chartPanelToggled: () => dispatch(ChartActions.chartPanelToggled())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(IceBuoyChartContainer)
)



// WEBPACK FOOTER //
// ./src/charts/IceBuoyChartContainer.js